module.exports = { "default": require("core-js/library/fn/symbol"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** /home/onlygamescl/onlygames-front/shared/~/babel-runtime/core-js/symbol.js
 ** module id = 204
 ** module chunks = 1
 **/